function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8656 5.85496L20.6456 8.64496C20.8356 8.83496 20.8356 9.15496 20.6356 9.34496L17.8556 12.135C17.5456 12.455 17.0056 12.235 17.0056 11.785V9.99496H10.9956C10.4456 9.99496 9.99563 9.54496 9.99563 8.99496C9.99563 8.44496 10.4456 7.99496 10.9956 7.99496H17.0156V6.20496C17.0156 5.76496 17.5556 5.53496 17.8656 5.85496ZM3.35563 14.645L6.13563 11.855C6.44563 11.535 6.98563 11.755 6.98563 12.205V13.995H12.9956C13.5456 13.995 13.9956 14.445 13.9956 14.995C13.9956 15.545 13.5456 15.995 12.9956 15.995H6.98563V17.795C6.98563 18.235 6.44563 18.465 6.13563 18.145L3.35563 15.355C3.16563 15.155 3.16563 14.845 3.35563 14.645Z",
    fill: "#9da3a8"
  }));
};
export default SvgComponent;
//# sourceMappingURL=swap_horiz.js.map